import { render, staticRenderFns } from "./orgEnterUpdate.vue?vue&type=template&id=4c56a7c4&scoped=true"
import script from "./orgEnterUpdate.vue?vue&type=script&lang=js"
export * from "./orgEnterUpdate.vue?vue&type=script&lang=js"
import style0 from "./orgEnterUpdate.vue?vue&type=style&index=0&id=4c56a7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c56a7c4",
  null
  
)

export default component.exports